/* v8 ignore start */
interface IMemoizationTarget {
  __memoized?: Record<string, {value: unknown}>;
}

export function memoize<T>(target: T, propertyKey: string, descriptor: PropertyDescriptor): void {
  if (descriptor.get) {
    const originalGetter = descriptor.get;

    descriptor.get = function (this: IMemoizationTarget): unknown {
      const memoizedProperties = this.__memoized || (this.__memoized = {});
      const memoized = memoizedProperties[propertyKey];

      if (memoized) {
        return memoized.value;
      }

      const value = originalGetter.apply(this);

      memoizedProperties[propertyKey] = {value};

      return value;
    };
  }
}
/* v8 ignore stop */
